import Vue from 'vue'

import {
  addComment,
  addInternalNote,
  canAccessTicket,
  createDraft,
  createInitialState,
  createTicket,
  deleteComment,
  editComment,
  getDraft,
  markAsRead,
  normalizeDraftContext,
  queryTickets,
  roleFromPermission,
  setCSAssignee,
  setTechnicalAssignees,
  updateTicket,
  updateAttachmentSharing,
} from './cs-issue-domain.mjs'

const state = Vue.observable(createInitialState())

export const csIssueRepository = {
  state,
  initializeRole(permission) {
    if (!state.roleInitialized) {
      state.demoRole = roleFromPermission(permission)
      Vue.set(state, 'roleInitialized', true)
    }
    return state.demoRole
  },
  resetForUser(permission) {
    const initial = createInitialState()
    state.notifications.splice(0, state.notifications.length, ...initial.notifications)
    state.demoRole = roleFromPermission(permission)
    Vue.set(state, 'roleInitialized', true)
  },
  setDemoRole(role) {
    state.demoRole = role
  },
  queryTickets(filters) {
    return queryTickets(state, { ...filters, role: state.demoRole })
  },
  getTicket(id) {
    const ticket = state.tickets.find(item => item.id === Number(id))
    return canAccessTicket(ticket, state.demoRole) ? ticket : null
  },
  createTicket(input) {
    return createTicket(state, input, state.demoRole)
  },
  updateTicket(id, patch) {
    return updateTicket(state, id, patch, state.demoRole)
  },
  setCSAssignee(id, assigneeId) {
    return setCSAssignee(state, id, assigneeId, state.demoRole)
  },
  setTechnicalAssignees(id, assigneeIds) {
    return setTechnicalAssignees(state, id, assigneeIds, state.demoRole)
  },
  addComment(id, input) {
    return addComment(state, id, { ...input, role: state.demoRole })
  },
  addInternalNote(id, body) {
    return addInternalNote(state, id, { role: state.demoRole, body })
  },
  editComment(id, commentId, body) {
    return editComment(state, id, commentId, body, state.demoRole)
  },
  deleteComment(id, commentId) {
    return deleteComment(state, id, commentId, state.demoRole)
  },
  updateAttachmentSharing(id, attachmentId, shared) {
    return updateAttachmentSharing(state, id, attachmentId, shared, state.demoRole)
  },
  markAsRead(id) {
    markAsRead(state, id, state.demoRole)
  },
  getNotifications() {
    return state.notifications.filter(item => !item.recipientRole || item.recipientRole === state.demoRole)
  },
  markNotificationRead(id) {
    const notification = state.notifications.find(item => String(item.id) === String(id))
    if (notification) Vue.set(notification, 'isRead', true)
    return notification || null
  },
  createDraft(source, payload) {
    return createDraft(state, normalizeDraftContext(source, payload))
  },
  getDraft(id) {
    return getDraft(state, id)
  },
}

export function openCSIssueDraft(router, source, payload = {}) {
  const draft = csIssueRepository.createDraft(source, payload)
  return router.push({ name: 'CSIssueCreate', query: { draft } }).catch(() => {})
}
